import React, { useState, useEffect } from 'react';
import useSetState from '../../../hooks/useSetState';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Spin from '../../../components/loading';
import Table from '../../../components/table';
import { giftChairsForSpecialUsersColumns } from '../../../enums/columns/giftChairsList';

const GiftChairs = () => {
  const [controls, setControls] = useSetState({
    sort: { sortType: 'desc', sortBy: 'price', sortQuery: '', filterQuery: '' }, pageNumber: 0,
    pageNumber: 0,
    pageSize: 10,
  });

  const onChangeValue = (controleName, value) => {
    setControls({ [controleName]: value });
  };

  // change table data after api ready
  const { reservationTimingList } = useSelector(state => ({
    reservationTimingList: state.reservationTimetableReducer.reservationTimingList,
  }));

  return (
    <Spin>
      <section>
        <div className="page-header">
          <h1>{locales('gift.chairs')}</h1>
          <div className="form-actions">
            <Link to='/packages/gift-chairs/add'
              className="btn btn-primary mx-1">
              <i className="fa fa-gift mx-1" />
              {locales('add.gift.chairs')}
            </Link>
          </div>
        </div>

        <div className='bg-white p-2'>
          <div className="panel-heading">
            <i className="fas fa-list-alt px-1" />
            {locales('titles.usersList')}
          </div>
          <div className='table-responsive-lg'>
            <Table
              columns={giftChairsForSpecialUsersColumns}
              dataSource={reservationTimingList}
              // loading={}
              sort={{ type: controls.sort.sortType }}
              pagination={{
                currentPage: controls.pageNumber,
                pageSize: controls.pageSize,
                totalCount: 0,
                // onPageChange: onPageChanged,
              }}
            />
          </div>
        </div>
      </section>
    </Spin>
  );
}

export default GiftChairs;